// https://stackoverflow.com/questions/48208665/how-to-update-merge-array-values-in-react-redux-correctly
export function mergeList(old, updated, key = 'uuid') {
  if (typeof updated !== 'object' || !updated.length) return [];

  const updatedArray = (old || [])
    .map((o) => {
      const v = updated.find((u) => u[key] === o[key]);

      if (!v) return null; // remove no longer existing

      return {
        ...o,
        ...v,
      };
    })
    .filter((n) => n);
  const newArray = updated.filter((u) => !updatedArray.some((v) => v[key] === u[key]));

  return updatedArray.concat(newArray);
}

export function payloadError(action) {
  if (!action || !action.payload || !action.payload.errors || !action.payload.errors.length) {
    return 'Something unexpected happened';
  }

  return action.payload.errors.join(', ');
}
